// src/admin/components/AdminLayout.jsx
import React from "react";
import Sidebar from "./Sidebar";
import HeaderBar from "../../components/HomePage/components/HeaderBar";

const AdminLayout = ({ children }) => {
  return (
    <div className="flex h-screen w-full bg-gray-50">
      <HeaderBar />
      {/* Sidebar */}
      <Sidebar />

      {/* Page content area */}
      <div className="flex flex-col flex-1 pt-16">
        <div className="p-6 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;
